import { KeyValPair } from "@models/common.model";
import { OptionsProps } from "./provider";

export type ActionType = 
    | {
        type: 'updateProduct' | 'updateContract' | 'updateProject' | 'updateProjectGroup' |
            'updateModule' | 'updateProfile' | 'updateRole' | 'updateOrganization'
        options: KeyValPair[],
      }

export default function OptionsReducer(state: OptionsProps, action: ActionType): OptionsProps {
    switch (action.type) {
        case 'updateProduct':
            return {
                ...state,
                product: action.options
            }
        case 'updateContract':
            return {
                ...state,
                contract: action.options
            }
        case 'updateProject':
            return {
                ...state,
                project: action.options
            }
        case 'updateProjectGroup':
            return {
                ...state,
                project_group: action.options
            }
        case 'updateModule':
            return {
                ...state,
                module: action.options
            }
        case 'updateProfile':
            return {
                ...state,
                profile: action.options
            }
        case 'updateRole':
            return {
                ...state,
                role: action.options
            }
        case 'updateOrganization':
            return {
                ...state,
                organization: action.options
            }
        default: 
            throw new Error();
    }
}